import { object, number, array, mixed } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType } from 'v2/constants';

export const referralsSettingsSchema = object().shape({
  rewardValue: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  freeSpinsCount: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  freeSpinsRewardChance: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  firstSpinRewardMinPercent: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  firstSpinRewardMaxPercent: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  defaultSpinRewardMaxPercent: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  defaultSpinRewardMinPercent: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  requiredTasksForReferralValidate: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  rewardsChances: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
});
